import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { KotItem, KotItemCreate, KotItemFilter } from '../data/kotItem';

export function createKotItemService(client: AxiosInstance) {
  return createCrudService<KotItem, KotItemCreate, KotItemFilter>(
    client,
    '/restaurant/KotItem',
    'id',
  );
}

export type KotItemService = CrudService<KotItem, KotItemCreate, KotItemFilter>;
